import React from 'react';
import { WixChatSmall, VisibleSmall } from '@wix/wix-ui-icons-common';
import { Box, Text } from '@wix/design-system';
import { DATA_HOOKS } from '../../../../dataHooks';
var Comments = function (_a) {
    var count = _a.count;
    return (React.createElement(Box, { gap: "3px" },
        React.createElement(WixChatSmall, null),
        React.createElement(Text, { dataHook: DATA_HOOKS.SEARCH_RESULT_COMMENTS_NUMBER, color: 'D20', size: "tiny" }, count)));
};
var Watch = function (_a) {
    var count = _a.count;
    return (React.createElement(Box, { gap: "3px" },
        React.createElement(VisibleSmall, null),
        React.createElement(Text, { dataHook: DATA_HOOKS.SEARCH_RESULT_WATCH_NUMBER, color: 'D20', size: "tiny" }, count)));
};
export var CommentsAndWatch = function (_a) {
    var watchCount = _a.watchCount, commentsCount = _a.commentsCount;
    return (React.createElement(Box, { dataHook: DATA_HOOKS.SEARCH_RESULT_COMMENTS_WATCH, gap: "SP1", color: 'D20' },
        commentsCount && React.createElement(Comments, { count: commentsCount }),
        watchCount && React.createElement(Watch, { count: watchCount })));
};
//# sourceMappingURL=index.js.map